import { render } from "./CustomCheckbox.vue?vue&type=template&id=8d188cf6&scoped=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"

import "./CustomCheckbox.vue?vue&type=style&index=0&id=8d188cf6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\18597-ocebio\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d188cf6"]])

export default __exports__